/* Cove at Home — theme.js */
(function () {
  'use strict';

  /* ============================================================
     QUANTITY INPUTS
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(1, current + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     PRODUCT VARIANT SWITCHING (basic)
     ============================================================ */
  var variantForms = document.querySelectorAll('[data-product-form]');
  variantForms.forEach(function (form) {
    var selects = form.querySelectorAll('[data-variant-option]');
    var hiddenId = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-product-price]');
    var priceWasEl = form.querySelector('[data-product-price-was]');
    var btn = form.querySelector('[data-add-button]');
    var variantsData;
    try {
      variantsData = JSON.parse(form.getAttribute('data-variants') || '[]');
    } catch (err) {
      variantsData = [];
    }

    function matchVariant() {
      var values = Array.from(selects).map(function (s) { return s.value; });
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function update() {
      var v = matchVariant();
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (priceWasEl) {
        if (v.compare_at_price && v.compare_at_price !== v.price) {
          priceWasEl.textContent = v.compare_at_price;
          priceWasEl.style.display = 'inline';
        } else {
          priceWasEl.style.display = 'none';
        }
      }
      if (btn) {
        if (v.available) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-text-add') || 'Add to bag';
        } else {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-text-soldout') || 'Sold out';
        }
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ============================================================
     PRODUCT IMAGE GALLERY
     ============================================================ */
  var thumbContainers = document.querySelectorAll('[data-product-thumbs]');
  thumbContainers.forEach(function (container) {
    var main = document.querySelector('[data-product-main-image]');
    if (!main) return;
    container.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var fullSrc = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (fullSrc) {
        main.src = fullSrc;
        main.alt = alt;
      }
      container.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  var toggle = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
